import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mathAbs',
  standalone: false,
})
export class MathAbsPipe implements PipeTransform {
  public transform(val: number): number {
    return Math.abs(val);
  }
}
